/**
 * 画面比例 chip 组(2026-09-13 F 批从 `VideoFormatRow` 抽出)。
 *
 * ★为什么抽成组件:老板要「时长和比例放一起」(时长独占一行浪费一半宽)。比例此前只活在
 *   `VideoFormatRow` 的画面层里,而时长在别处(目的流的独立时长卡 / 自由创作的单段时长行)。
 *   把比例挪到时长那一行,若各处再抄一遍 chips + lockedFields 写入,就是**第二处判据**必漂移
 *   —— 尤其 lockedFields 的写入语义(波3-⑦:同一字段两个入口必须同一套语义,否则 AI 编排回填
 *   会把用户改的悄悄覆盖回去)绝不能有第二份。故收成单一组件,VideoFormatRow / 时长行都引它。
 * ★比例入口 / lockedFields 写入逻辑与抽出前**逐字一致**(只是换了个渲染位置)。
 */
import type { Dispatch, SetStateAction } from "react";

import { type FormState, withUserLocks } from "../../model/videoCreateTypes";

import { OptionChip, OptionChipGroup } from "./OptionChip";

const RATIO_OPTIONS = [
  { label: "竖屏 9:16", value: "9:16" },
  { label: "横屏 16:9", value: "16:9" },
  { label: "方形 1:1", value: "1:1" },
];

interface Props {
  form: FormState;
  setForm: Dispatch<SetStateAction<FormState>>;
  disabled?: boolean;
}

export function VideoRatioChips({ form, setForm, disabled }: Props) {
  return (
    <div>
      <span className="mb-1.5 block text-sm text-muted-foreground">比例 · 平台</span>
      <OptionChipGroup label="画面比例">
        {RATIO_OPTIONS.map((r) => {
          const active = form.ratio === r.value;
          return (
            <OptionChip
              key={r.value}
              radio
              active={active}
              tabIndex={active ? 0 : -1}
              disabled={disabled}
              onClick={() =>
                setForm((f) => ({
                  ...f,
                  ratio: r.value,
                  lockedFields: withUserLocks(f.lockedFields, { ratio: r.value }),
                }))
              }
            >
              {r.label}
            </OptionChip>
          );
        })}
      </OptionChipGroup>
    </div>
  );
}
